// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectsPage_wrapper__dFgu7","projectSite":"ProjectsPage_projectSite__7Ph1I","projectAnother":"ProjectsPage_projectAnother__AGrsI"};